/** Веб-академия (где ученики проходят курсы). Переопределяется на деве. */
export const ACADEMY_WEB_URL =
  (import.meta.env.VITE_ACADEMY_WEB_URL as string | undefined) ?? 'https://learn.open-academy.app'

/** Страница курса в веб-академии: `/library/{slug}`. Курс «по ссылке» по номеру
 *  посторонним не открывается (404), поэтому ссылки строятся из кода курса.
 *  Единственное исключение — редирект старого `/course/:id`. */
export const academyCourseUrl = (slug: string): string => `${ACADEMY_WEB_URL}/library/${slug}`
